import {
	Input as InputComponent,
	type InputProps as InputPropsType
} from './Input';

export const Input = InputComponent;
export type InputProps = InputPropsType;
